var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "b-card-actions",
        {
          attrs: {
            "show-loading": _vm.uploading,
            "action-collapse": "",
            title: _vm.$t("Dados da Requisição"),
          },
        },
        [
          _c(
            "FormulateForm",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.uploading,
                  expression: "!uploading",
                },
              ],
              ref: "form",
            },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("e-store-combo", {
                        attrs: {
                          id: "store-combo",
                          name: "storeId",
                          required: "",
                          "is-read-only":
                            _vm.readOnly ||
                            _vm.purchaseRequisition.status === "Completed" ||
                            _vm.isSubmitToSupplier,
                          clearable: false,
                        },
                        model: {
                          value: _vm.purchaseRequisition.storeId,
                          callback: function ($$v) {
                            _vm.$set(_vm.purchaseRequisition, "storeId", $$v)
                          },
                          expression: "purchaseRequisition.storeId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "group-combo",
                          name: "groupId",
                          type: _vm.isGroupReadOnly ? "label" : "vue-select",
                          label: _vm.$t("Grupo de produto"),
                          placeholder: _vm.$t("Todos os grupos"),
                          options: _vm.getComboGroups,
                          instruction: _vm.$t(
                            "Quando informado, somente produtos do grupo selecionado poderão ser incluídos na requisição"
                          ),
                        },
                        model: {
                          value: _vm.purchaseRequisition.groupId,
                          callback: function ($$v) {
                            _vm.$set(_vm.purchaseRequisition, "groupId", $$v)
                          },
                          expression: "purchaseRequisition.groupId",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.isEdit
                    ? _c(
                        "b-col",
                        { attrs: { md: "4" } },
                        [
                          !!_vm.approvalFlowRoute
                            ? _c("FormulateInput", {
                                attrs: {
                                  id: "status-label",
                                  value: _vm.purchaseRequisitionStatus,
                                  type: "label",
                                  label: _vm.$t("Status"),
                                  "router-to": _vm.approvalFlowRoute,
                                },
                              })
                            : _c(
                                "div",
                                [
                                  _c("FormulateInput", {
                                    attrs: {
                                      id: "status-label",
                                      value: _vm.purchaseRequisition.status,
                                      type: "label",
                                      label: _vm.$t("Status"),
                                      options:
                                        _vm.mxPurchaseRequisitionStatusOptions(),
                                      "is-badge": "",
                                    },
                                  }),
                                ],
                                1
                              ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.purchaseRequisition.status === "Deleted"
                    ? [
                        _c(
                          "b-col",
                          { attrs: { md: "2" } },
                          [
                            _c("FormulateInput", {
                              attrs: {
                                id: "deleted_date",
                                value: _vm.purchaseRequisition.deletedDate,
                                type: "label",
                                filter: "datetime",
                                label: _vm.$t("Data da exclusão"),
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "2" } },
                          [
                            _c("FormulateInput", {
                              attrs: {
                                id: "deleted_by",
                                value: _vm.purchaseRequisition.deletedBy
                                  ? _vm.purchaseRequisition.deletedBy.name
                                  : "",
                                type: "label",
                                label: _vm.$t("Excluído por"),
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "4" } },
                          [
                            _c("FormulateInput", {
                              attrs: {
                                id: "deleted_reason",
                                value: _vm.purchaseRequisition.deletedReason,
                                type: "label",
                                label: _vm.$t("Motivo da exclusão"),
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                  _vm.isEdit
                    ? [
                        _c(
                          "b-col",
                          { attrs: { md: "4" } },
                          [
                            _c("FormulateInput", {
                              attrs: {
                                id: "requested_date",
                                value: _vm.purchaseRequisition.requestedDate,
                                type: "label",
                                filter: "datetime",
                                label: _vm.$t("Data de criação"),
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "4" } },
                          [
                            _c("FormulateInput", {
                              attrs: {
                                id: "origin",
                                value: _vm.$t(
                                  "PurchaseRequisition.Origin." +
                                    _vm.purchaseRequisition.origin
                                ),
                                type: "label",
                                label: _vm.$t("Origem da requisição"),
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "4" } },
                          [
                            _c("FormulateInput", {
                              attrs: {
                                id: "requested_by_user",
                                value: _vm.purchaseRequisition.requestedByUser
                                  ? _vm.purchaseRequisition.requestedByUser.name
                                  : "",
                                type: "label",
                                label: _vm.$t("Usuário que requisitou"),
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                  _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c("FormulateInput", {
                        staticClass: "required",
                        attrs: {
                          id: "observation",
                          name: "observation",
                          type: _vm.isObservationReadOnly
                            ? "label"
                            : "textarea",
                          label: _vm.$t("Observação"),
                          validation: _vm.isObservationRequired
                            ? "required"
                            : "",
                        },
                        model: {
                          value: _vm.purchaseRequisition.observation,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.purchaseRequisition,
                              "observation",
                              $$v
                            )
                          },
                          expression: "purchaseRequisition.observation",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.purchaseRequisition.storeId
        ? [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { md: "12" } },
                  [
                    _c(
                      "b-card-actions",
                      {
                        attrs: {
                          "show-loading": _vm.saving,
                          "action-collapse": "",
                          title: _vm.$t("Itens da Requisição"),
                        },
                      },
                      [
                        _c("order-items", {
                          ref: "orderItems",
                          attrs: {
                            "is-xml": "",
                            "purchase-requisition": _vm.purchaseRequisition,
                            "can-manage": _vm.canEditItemsInSubmitToSupplier,
                          },
                          on: {
                            "update-average-prices":
                              _vm.onUpdateItemsAveragePrices,
                            "add-item": _vm.onAddItem,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("product-sidebar", {
              ref: "productSidebar",
              attrs: { "store-id": _vm.purchaseRequisition.storeId },
            }),
          ]
        : _vm._e(),
      _vm.isEdit &&
      _vm.purchaseRequisition.supplierOrders &&
      _vm.purchaseRequisition.supplierOrders.length > 0
        ? [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { md: "12" } },
                  [
                    _c(
                      "b-card-actions",
                      {
                        attrs: {
                          "action-collapse": "",
                          title: _vm.$t("Pedidos aos Fornecedores"),
                        },
                      },
                      [
                        _c("b-table", {
                          staticClass: "bordered",
                          attrs: {
                            responsive: "",
                            striped: "",
                            fields: _vm.supplierOrderFields,
                            items: _vm.purchaseRequisition.supplierOrders,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "cell(requestedDate)",
                                fn: function (row) {
                                  return [
                                    _vm.editingOrderIndex === row.index
                                      ? [
                                          _c("FormulateInput", {
                                            staticClass: "w-100 required",
                                            attrs: {
                                              id: "requested_date_" + _vm.index,
                                              type: "datepicker",
                                              validation: "required",
                                            },
                                            model: {
                                              value: row.item.requestedDate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  row.item,
                                                  "requestedDate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "row.item.requestedDate",
                                            },
                                          }),
                                        ]
                                      : [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm._f("date")(
                                                  row.item.requestedDate
                                                )
                                              ) +
                                              " "
                                          ),
                                        ],
                                  ]
                                },
                              },
                              {
                                key: "cell(orderNumber)",
                                fn: function (row) {
                                  return [
                                    _vm.editingOrderIndex === row.index
                                      ? [
                                          _c("b-form-input", {
                                            attrs: { type: "text", size: "sm" },
                                            model: {
                                              value: row.item.orderNumber,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  row.item,
                                                  "orderNumber",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "row.item.orderNumber",
                                            },
                                          }),
                                        ]
                                      : [
                                          _vm._v(
                                            " " +
                                              _vm._s(row.item.orderNumber) +
                                              " "
                                          ),
                                        ],
                                  ]
                                },
                              },
                              {
                                key: "cell(supplier)",
                                fn: function (row) {
                                  return [
                                    _vm.editingOrderIndex === row.index
                                      ? [
                                          _c("e-person-search", {
                                            staticClass: "w-100",
                                            attrs: {
                                              "is-supplier": "",
                                              "value-is-object": "",
                                              "show-label": false,
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.onSupplierSelectedInline(
                                                  $event,
                                                  row.index
                                                )
                                              },
                                            },
                                            model: {
                                              value: row.item.supplier,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  row.item,
                                                  "supplier",
                                                  $$v
                                                )
                                              },
                                              expression: "row.item.supplier",
                                            },
                                          }),
                                        ]
                                      : [
                                          _vm._v(
                                            " " +
                                              _vm._s(row.item.supplier) +
                                              " "
                                          ),
                                        ],
                                  ]
                                },
                              },
                              {
                                key: "cell(attachments)",
                                fn: function (row) {
                                  return [
                                    row.item.attachments &&
                                    row.item.attachments.length > 0
                                      ? _c(
                                          "div",
                                          _vm._l(
                                            row.item.attachments,
                                            function (url, index) {
                                              return _c(
                                                "b-link",
                                                {
                                                  key: index,
                                                  attrs: {
                                                    href: url,
                                                    target: "_blank",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " Anexo " +
                                                      _vm._s(index + 1) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          1
                                        )
                                      : _c("span", [_vm._v("-")]),
                                  ]
                                },
                              },
                              {
                                key: "cell(actions)",
                                fn: function (row) {
                                  return [
                                    _vm.editingOrderIndex === row.index
                                      ? [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                gap: "5px",
                                              },
                                            },
                                            [
                                              _c("e-button", {
                                                staticClass: "px-1",
                                                attrs: {
                                                  title: "Confirmar",
                                                  icon: "check",
                                                  variant: "success",
                                                  size: "sm",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onConfirmEditSupplierOrder(
                                                      row.index
                                                    )
                                                  },
                                                },
                                              }),
                                              _c("e-button", {
                                                staticClass: "px-1",
                                                attrs: {
                                                  title: "Cancelar",
                                                  icon: "x",
                                                  variant: "outline-secondary",
                                                  size: "sm",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onCancelEditSupplierOrder()
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      : [
                                          _c("e-grid-actions", {
                                            attrs: {
                                              "show-update": !_vm.readOnly,
                                              "show-delete": !_vm.readOnly,
                                            },
                                            on: {
                                              delete: function ($event) {
                                                return _vm.onDeleteSupplierOrder(
                                                  row.index
                                                )
                                              },
                                              update: function ($event) {
                                                return _vm.onEditSupplierOrderInline(
                                                  row.index
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2559410150
                          ),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm.isEdit &&
      _vm.purchaseRequisition.purchaseOrders &&
      _vm.purchaseRequisition.purchaseOrders.length > 0
        ? [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { md: "12" } },
                  [
                    _c(
                      "b-card-actions",
                      {
                        attrs: {
                          "action-collapse": "",
                          title: _vm.$t("Pedidos de Compra Associados"),
                        },
                      },
                      [
                        _c("b-table", {
                          staticClass: "bordered",
                          attrs: {
                            responsive: "",
                            striped: "",
                            fields: _vm.purchaseOrderFields,
                            items: _vm.purchaseRequisition.purchaseOrders,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "cell(purchaseOrderId)",
                                fn: function (row) {
                                  return [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: _vm.purchaseOrderRoute(row.item),
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(row.item.purchaseOrderId) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "cell(status)",
                                fn: function (row) {
                                  return [
                                    _c("e-status-badge", {
                                      attrs: {
                                        status: row.item.status,
                                        options:
                                          _vm.mxPurchaseOrderStatusOptions(),
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1796722166
                          ),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
      _c("modal-cancel-purchase-requisition", {
        ref: "modalCancel",
        on: {
          "after-confirm": function () {
            return _vm.$router.back()
          },
        },
      }),
      _c("modal-submit-supplier-order", {
        ref: "modalSubmitSupplierOrder",
        attrs: { "purchase-requisition-id": _vm.purchaseRequisition.id || 0 },
        on: { "after-confirm": _vm.onSupplierOrderAdded },
      }),
      _c("e-crud-actions", {
        attrs: {
          "show-save": false,
          busy: _vm.saving,
          "additional-actions": _vm.additionalActions,
        },
        on: {
          saveDraft: _vm.onSaveDraft,
          cancel: _vm.onCancelSubmit,
          reevaluate: _vm.onSubmitOrder,
          submit: _vm.onSubmitOrder,
          completeRequisition: _vm.onCompleteRequisition,
          cancelRequisition: _vm.onCancel,
          submitSupplier: _vm.onSubmitSupplier,
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }